<div class="credit-card-verification-dialog m-3">
    <lib-verify-billing-address-credit-card
        [billingAddress]="billingAddress"
        [activeProfileView]="''"
        (addressUpdateResult)="onAddressUpdateResult($event)"
        (cancelClicked)="onCancel()"
    />
</div>
